export type DataSource = "ga4" | "log-analytics" | "auth0" | "bigquery";

const LABEL: Record<DataSource, string> = {
  ga4: "GA4",
  "log-analytics": "Log Analytics",
  auth0: "Auth0",
  bigquery: "QuantumMetric",
};

const STYLE: Record<DataSource, string> = {
  ga4: "bg-amber-500/15 text-amber-300 ring-amber-500/30",
  "log-analytics": "bg-violet-500/15 text-violet-300 ring-violet-500/30",
  auth0: "bg-orange-500/15 text-orange-300 ring-orange-500/30",
  bigquery: "bg-teal-500/15 text-teal-300 ring-teal-500/30",
};

interface SourceBadgeProps {
  source: DataSource;
  /** When true, render a "synthetic" hint (data came from the stub fallback). */
  synthetic?: boolean;
}

/** Tells the viewer which upstream produced a panel's numbers. */
export function SourceBadge({ source, synthetic }: SourceBadgeProps) {
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-medium uppercase tracking-wide ring-1 ${STYLE[source]}`}
      title={`Data source: ${LABEL[source]}${synthetic ? " (synthetic — backend running on stub data)" : ""}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {LABEL[source]}
      {synthetic && <span className="opacity-70">· synthetic</span>}
    </span>
  );
}
